module.exports = __webpack_public_path__ + "img/guitar.b6f594d4.png";